import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import AccessDeniedModal from '../AccessDeniedModal';
import modalActions from '../../redux/modal/actions';

const MODAL_COMPONENTS = {
  ACCESS_DENIED: AccessDeniedModal,
};

interface IModalRootProps {
  modalType: string;
  modalProps: any;
  modalVisibility: boolean;
  closeModal: () => void;
}

const GlobalModalRoot = ({ modalType, modalProps, modalVisibility, closeModal }: IModalRootProps) => {
  if (!modalType || !MODAL_COMPONENTS[modalType as keyof typeof MODAL_COMPONENTS]) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType as keyof typeof MODAL_COMPONENTS];
  
  return (
    <SpecificModal
      visible={modalVisibility}
      onClose={modalProps.onClose || closeModal}
      {...modalProps}
    />
  );
};

export default connect(
  (state: any) => state.modal,
  { ...modalActions }
)(GlobalModalRoot);
